import { render, staticRenderFns } from "./BLHSG03Component.vue?vue&type=template&id=21a9785e&scoped=true&"
import script from "./BLHSG03Component.vue?vue&type=script&lang=js&"
export * from "./BLHSG03Component.vue?vue&type=script&lang=js&"
import style0 from "./BLHSG03Component.vue?vue&type=style&index=0&id=21a9785e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9785e",
  null
  
)

export default component.exports